// Angular
import { Component, OnInit, ViewChild, AfterContentInit, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
// Models
import { MatSnackBar } from "@angular/material";

import { Tournament } from "./../../models/tournament";
import { Club } from "./../../models/club";
// External
import { Router } from "@angular/router";
import * as moment from "moment";

import { Player, Team } from "./../../models/team";
import { AngularFireDatabase } from "angularfire2/database";
import { ApiService } from "../../services/api";

import * as lodash from "lodash";
import { TabsetComponent } from "ngx-bootstrap";
import { log } from "util";
import { FormBuilder, FormGroup } from "@angular/forms";
import { OAuthService } from "app/services/o-auth";
import { T } from "@angular/core/src/render3";
import { Subject } from "rxjs";
import { environment } from './../../../environments/environment';

// import { saveAs } from "file-saver";

@Component({
  templateUrl: "./tournament.detail.component.html",
  styleUrls: ["./tournament-details.component.scss"],
})
export class TournamentDetailComponent implements OnInit, AfterContentInit {
  ngAfterContentInit() {}
  @ViewChild("staticTabs") staticTabs: TabsetComponent;

  public notificationMessage: string = "";
  public emailMessage: string = "";
  public tournament: any = {};
  public club: Club;
  public imageLoader = true;
  public players: Array<any>;
  public manualPlayers: Array<any>;
  public uplayers: Array<any>;
  public umanualPlayers: Array<any>;
  public team: any;
  public teamData: any;
  public filterargs: Player;
  public enteries: Array<any> = [];
  public notificationEntries: Array<any> = [];
  public isShowImage = false;
  public tournamentId: string;
  public counter: number;
  public startHoles: Array<any>;
  public ucounter: number;
  public print: any;
  public printTeams: Array<any>;
  public teams: Array<any>;
  public isEdit = false;
  public goLive = false;
  public user: any;
  public leaderboards: Array<any> = [];
  public leaderboardList: Array<any> = [];
  public isStableford = false;
  public notificationList: Array<any> = [];
  public emailList: Array<any> = [];
  public slop_rating = 0;
  public startType = 0;
  public startTime;
  public startTime_options = [];
  public groupSize = 4;
  public teeInterval = 10;
  public startTypes = [];
  public fillGroups = 1;
  public isOpenInviteUserModal = false;
  public isOpenInviteUserModalNew = false;
  public isOpenResetGroupModal = false;
  public selectedTab = 0;
  public openTeamEditModal = false;
  public showAction: string;
  public addTeam = [];


  // public offer: any;
  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private fireDatabase: AngularFireDatabase,
    private oAuthService: OAuthService,
    private apiService: ApiService,
    public snackBar: MatSnackBar,
    private router: Router
  ) {
    this.user = {};
    this.team = {
      name: "Team-",
      date: new Date(),
      startHole: 1,
    };
    this.filterargs = new Player();
    this.players = [];
    this.manualPlayers = [];
    this.counter = 0;
    this.ucounter = 0;
    this.teamData = {
      name: "",
      startHole: 1,
    };
    this.print = {
      name: "",
      clubName: "",
      date: "",
    };
    // this.players.push({ id: "", handicap: 0 })
  }

  onShowAction(key: string) {
    this.showAction = key;
  }

  closeAction()
  {
    this.showAction = ""
  }
  
  onTabChange(event)
  {
    this.selectedTab = event;
  }

  ongroupCreatedChange(event)
  {
    this.tournament.isGroupCreated = event;
  }

  openInviteUserModal(event)
  {
    this.isOpenInviteUserModal = true;
    $("#invite-users-new").modal('show');
  }

  openInviteUserModalNew(event)
  {
    this.isOpenInviteUserModalNew = true;
    $("#invite-users-new").modal('show');
  }
  createGroupsSubject: Subject<any> = new Subject<any>();

  fillGroupsSubject: Subject<any> = new Subject<any>();

  resetGroupsSubject: Subject<any> = new Subject<any>();

  syncLocalTeams: Subject<any> = new Subject<any>();
  
  onRandomFillGroups(event)
  {
    this.fillGroupsSubject.next(+this.fillGroups);
  }

  onCreateGroups(event)
  {
    this.tournament.isGroupCreated = true;
    let obj = {
      groupSize: +this.groupSize,
      teeInterval: this.teeInterval,
      startType: +this.startType
    }
    this.fireDatabase.database.ref(`tournaments/${this.tournamentId}/isGroupCreated`).set(true);
    this.fireDatabase.database.ref(`tournaments/${this.tournamentId}/groupSize`).set(this.groupSize);
    this.fireDatabase.database.ref(`tournaments/${this.tournamentId}/teeInterval`).set(this.teeInterval);
    this.fireDatabase.database.ref(`tournaments/${this.tournamentId}/startType`).set(this.startType);

    this.createGroupsSubject.next(obj);
  }
  openResetModal(event){
    this.isOpenResetGroupModal = true;
    $("#OpenResetGroupModal").modal('show');
  }

  onResetGroups(event)
  {
    this.resetGroupsSubject.next();
    this.tournament.isGroupCreated = false;
    this.fireDatabase.database.ref(`tournaments/${this.tournamentId}/isGroupCreated`).set(false);
  }

  selectTab(tab_id: number) {
    this.staticTabs.tabs[tab_id].active = true;
  }

  async ngOnInit() {
    this.user = this.oAuthService.getClub();
    this.tournamentId = this.route.snapshot.paramMap.get("id");
    this.tournament = await this.apiService.object(
      `/tournaments/${this.tournamentId}`
    );

    if (this.tournament.slopeRating) {
      this.slop_rating = this.tournament.slopeRating;
    } else {
      this.slop_rating = 113;
    }

    this.isStableford = false;
    if (this.tournament.type != undefined) {
      this.isStableford = this.tournament.type == 0 ? false : true;
    }
    if (
      this.tournament.originalImage == null ||
      this.tournament.originalImage == undefined
    ) {
      this.tournament.originalImage = this.tournament.image;
    }
    if (!this.tournament.isFixtureShow) {
      this.tournament.isFixtureShow = false;
    }
    let uid = this.tournament.userId
      ? this.tournament.userId
      : this.tournament.uid;
    let user = await this.apiService.object("users/" + uid);
    let profile = await this.apiService.object(
      "user-profiles/" + this.tournament.userId + "/" + this.tournament.uid
    );
    user.profile = profile;
    this.tournament.user = user;
    // this.enteries = [];

    this.print.name = this.tournament.eventName;
    this.print.date = this.formatDate(new Date());
    this.tournament.handicap_percentage =
      this.tournament.handicap_percentage != undefined
        ? this.tournament.handicap_percentage
        : 100;
    const startTime = parseFloat(this.tournament.startDate) * 1000;
    const endTime = parseFloat(this.tournament.endDate) * 1000;
    const current = new Date().getTime();
    this.startHoles = [];

    switch (this.tournament.holesPart) {
      case 1:
        for (let i = 0; i < 9; i++) {
          this.startHoles.push(i + 1);
        }
        this.startTypes = [
          { id: 1, name: "Hole 1" },
          { id: 3, name: "Shotgun" },
        ];

        this.startType = 1;
        break;
      case 2:
        for (let i = 9; i < 18; i++) {
          this.startHoles.push(i + 1);
        }
        this.startTypes = [
          { id: 10, name: "Hole 10" },
          { id: 3, name: "Shotgun" },
        ];
        this.startType = 10;
        break;
      default:
        for (let i = 0; i < 18; i++) {
          this.startHoles.push(i + 1);
        }
        this.startTypes = [
          { id: 1, name: "Hole 1" },
          { id: 10, name: "Hole 10" },
          { id: 2, name: "Hole 1 and 10" },
          { id: 3, name: "Shotgun" },
        ];
        this.startType = 1;
        break;
    }
    this.team = {
      name: "Team-",
      startHole: this.startHoles[0],
    };
    
    if (current > endTime) {
      this.isEdit = false;
      this.tournament.isFinished = true;
      this.tournament.status = "Finished";
    } else if (startTime > current) {
      const days = Math.floor(
        Math.abs((startTime - current) / (24 * 60 * 60 * 1000))
      );
      if (days < 1) {
        this.isEdit = true;
        this.tournament.status = (await this.getTimeDifference(startTime)) + "to start";
        this.tournament.isFinished = false;
      } else {
        this.isEdit = true;
        this.tournament.status = (await this.getTimeDifference(startTime)) + "to start";
        this.tournament.isDelete = true;
        this.tournament.isFinished = false;
      }
    } else {
      this.tournament.status = "Active";
      this.isEdit = true;
      this.tournament.isFinished = false;
    }


    this.fireDatabase
      .object(`/users/${this.tournament.cid}`)
      .subscribe((club) => {
        this.club = club;
        this.print.clubName = club.name;
      });
    this.imageLoader = false;

    await this.getTournamentTeams();
    await this.getTournamentEnteries();
    //await this.getSlopRating();

    // this.getLiveData()
  }

  public getTimeDifference(givenTime: number) {
    const current = new Date().getTime() / 1000;
    const min = Math.abs((current - givenTime) / 60);
    const hour = min / 60;
    const day = hour / 24;
    const month = day / 30;
    const year = month / 12;
    if (year < 1) {
      if (month < 1) {
        if (day < 1) {
          if (hour < 1) {
            if (min > 10) {
              return parseInt(min + "") + " min ";
            } else {
              return "few mins ";
            }
          } else {
            if (hour < 2) {
              return parseInt(hour + "") + " hr ";
            } else {
              return parseInt(hour + "") + " hrs ";
            }
          }
        } else {
          const d = parseInt(day + "");
          const rh = parseInt(hour - 24 * d + "");
          if (day < 2) {
            return d + " day " + rh + " hrs ";
          } else {
            return d + " day " + rh + " hrs ";
          }
        }
      } else {
        if (month < 2) {
          return parseInt(month + "") + " month ";
        } else {
          return parseInt(month + "") + " months ";
        }
      }
    } else {
      if (year < 2) {
        return parseInt(year + "") + " year ";
      } else {
        return parseInt(year + "") + " years ";
      }
    }
  }

  async getSlopRating() {
    let st = await this.apiService.object(
      `/tee-slope-ratings/${this.tournament.cid}/${this.tournament.course}/${this.tournament.tee}/verifiedSlopRating`
    );
    this.slop_rating = JSON.parse(JSON.stringify(st)).$value;
  }
  getTournamentEnteries() {
    
    this.fireDatabase
      .object(`/tournaments/${this.tournamentId}/enteries`)
      .subscribe((res) => {
        let newEntries = [];
        this.enteries = [];
        let list = [];
        if (res) {
          lodash.forEach(res, (item, key) => {
            if (item) {
                this.apiService.object(`/users/${key}`).then((user) => {
                  user.key = key;
                  newEntries.push(user);
                  user.isNotification = false;
                  user.isEmail = false;
                  // this.notificationList.push(user);
                  list.push(user);
                  // this.emailList.push(user);
                  this.enteries = newEntries;
                });
            }
          });
        }
        this.notificationList = list;
        this.emailList = list;
      });
  }
  clickedTeam;
  getTournamentTeams() {
    this.fireDatabase
      .object(`/tournament-fixtures/${this.tournamentId}`)
      .subscribe((team) => {
        let count = 1;
        this.teams = [];
        this.printTeams = [];
        lodash.forEach(team, (item, key) => {
          if (item) {
            item.printTime = this.formatTime(item.date);
            const t: any = item;
            t.$key = key;
            t.playerss = [];
            t.code = item.code;
            t.name = item.name;
            t.startHole = item.startHole;
            lodash.forEach(item.players, (item1, uid) => {
              this.apiService
                .object(`/users/${uid}`)
                .then((result) => {
                  const handicap = item.handicaps[uid];
                  const userEntry = {
                    name: result.fullName,
                    isPro: Math.round(handicap) <= 0 ? true : false,
                    handicap: handicap,
                    $key: uid
                  };
                  t.playerss.push(userEntry);
                })
                .catch((error) => {
                  alert(error);
                });
            });
            lodash.forEach(item.manual_players, (item1, muid) => {
              item1.$key = muid;
              item1.handicap = item.handicaps[muid]
              item1.$key  = muid
                // item.tournamentHandicap[muid] == undefined
                //   ? item1.handicap
                //   : item.tournamentHandicap[muid];

              t.playerss.push(item1);
            });
            count++;
            this.team.name = "Team-" + count;
            this.printTeams.push(item);
            this.teams.push(t);

            if (count === 2) {
              this.selectedTeam(t);
            }
          } else {
            this.teamData = {
              name: "",
              date: new Date(),
              startHole: 1,
            };
          }
        });
      });
  }

  openModal(event)
  {
    this.openTeamEditModal = true;
    this.selectedTeam(this.clickedTeam);
  }

  getHolesPart(): string {
    let part = `All ${this.tournament.holesCount}`;

    if (this.tournament.holesPart === 1) {
      part = "First 9";
    }

    if (this.tournament.holesPart === 2) {
      part = "Last 9";
    }
    return part;
  }

  changeClub(user: any, p?) {

    if (user) {
      p.handicap = user.handicap;
      p.thandicap = user.handicap;
      p.id = user.$key;
      (p.name = user.fullName), (p.user = user);
      if (this.tournament.proAm == true) {
        if (user.isPro) {
          this.team.name = p.name + "'s Team";
        }
      }
    } else {
      p.handicap = "";
      p.id = "";
      (p.name = ""), (p.user = null);
    }
  }
  addPlayer() {
    this.counter++;
    if (this.counter === 1) {
      this.players.push({
        id: "",
        handicap: "",
        isMain: true,
        isNameError: false,
        isHandicapError: false,
      });
    } else {
      this.players.push({
        id: "",
        handicap: "",
        isMain: this.players.length == 0 ? true : false,
        isNameError: false,
        isHandicapError: false,
      });
    }
  }
  addManualPlayer() {
    this.counter++;
    if (this.counter === 1) {
      this.manualPlayers.push({
        id: "",
        name: "",
        handicap: "",
        isMain: false,
        isNameError: false,
        isHandicapError: false,
      });
    } else {
      this.manualPlayers.push({
        id: "",
        name: "",
        handicap: "",
        isMain: false,
        isNameError: false,
        isHandicapError: false,
      });
    }
  }

  subPlayer(i) {
    this.counter--;
    if (this.tournament.proAm) {
      if (this.players[i].handicap != "" && this.players[i].handicap == 0.0) {
        this.team.name = this.team.name.replace(
          this.players[i].user.fullName,
          ""
        );
        this.players.splice(i, 1);
        this.players.forEach((player) => {
          if (player.handicap == 0.0) {
            this.team.name = player.user.fullName + "'s Team";
          }
        });
      } else {
        this.players.splice(i, 1);
      }
      this.players[0].isMain = true;
    } else {
      this.players.splice(i, 1);
      this.players[0].isMain = true;
    }
  }

  trimString(string)
  {
    if(string)
      return string.trim();
    else return ""
  }

  subManualPlayer(i) {
    this.counter--;
    this.manualPlayers.splice(i, 1);
  }
  checkCounter() {
    if (this.counter < 4) {
      return true;
    } else {
      return false;
    }
  }
  isMainChange(p, event) {
    for (let i = 0; i < this.manualPlayers.length; i++) {
      this.manualPlayers[i].isMain = false;
    }
    for (let j = 0; j < this.players.length; j++) {
      this.players[j].isMain = false;
    }
    p.isMain = true;
  }
  selectedTeam(t) {
    this.clickedTeam = t;
    console.log("selected team",t)
    this.ucounter = 0;
    this.teamData = t;
    this.umanualPlayers = [];
    this.uplayers = [];
    lodash.forEach(t.manual_players, (item, key) => {
      this.ucounter++;
      this.umanualPlayers.push(
        Object.assign(item, { isNameError: false, isHandicapError: false })
      );
    });
    lodash.forEach(t.players, (item, key) => {
      this.apiService.object(`/users/${key}`).then((user) => {
        user.name = user.fullName;
        user.originalhandicap = user.handicap;
        this.ucounter++;
        this.uplayers.push(
          Object.assign(user, {
            id: key,
            thandicap: t.tournamentHandicap[key],
            isNameError: false,
            isHandicapError: false,
            handicap: t.handicaps[key],
          })
        );
      });
    });
  }
  uaddPlayer() {
    this.ucounter++;
    this.uplayers.push({ id: "", handicap: 0 });
  }
  uaddManualPlayer() {
    this.ucounter++;
    this.umanualPlayers.push({ name: "", handicap: 0 });
  }

  usubPlayer(i) {
    this.ucounter--;
    this.uplayers.splice(i, 1);
  }
  usubManualPlayer(i) {
    this.ucounter--;
    this.umanualPlayers.splice(i, 1);
  }

  checkBeforeSubmit() {
    let teamCount = 0;

    if (this.team.name == ""|| this.team.name == "Team-") {
      alert("Please enter team name!!");
      return false;
    }

    if (this.players.length == 0) {
      alert("Atleast one system player is required to create a team!!");
      return false;
    }

    if (this.tournament.team == 2) {
      let temp = true;
      for (let index = 0; index < this.players.length; index++) {
        const element = this.players[index];
        if ("user" in element && element.user.isPro) {
          temp = false;
          break;
        }
      }

      if (temp) {
        alert("Atleast one Pro is required per team!");
        return false;
      }
    }

    if (this.tournament.proAm) {
      let proCount = 0;
      for (let index = 0; index < this.players.length; index++) {
        const element = this.players[index];
        if ("user" in element && element.user.isPro) {
          ++proCount;
        }
      }

      if (proCount >= 2) {
        alert("You have selected too many pros!");
        return false;
      }
    }

    lodash.forEach(this.players, (item, key) => {
      if (item.id === "" || item.id === null) {
        ++teamCount;
        this.players[key].isNameError = true;
      } else {
        this.players[key].isNameError = false;
      }
      if (item.handicap === "" || item.handicap === null) {
        ++teamCount;
        this.players[key].isHandicapError = true;
      } else {
        this.players[key].isHandicapError = false;
      }
    });
    lodash.forEach(this.manualPlayers, (item, key) => {
      if (item.name === "" || item.name === null) {
        ++teamCount;
        this.manualPlayers[key].isNameError = true;
      } else {
        this.manualPlayers[key].isNameError = false;
      }
      if (item.handicap === "" || item.handicap === null) {
        ++teamCount;
        this.manualPlayers[key].isHandicapError = true;
      } else {
        this.manualPlayers[key].isHandicapError = false;
      }
    });

    if (teamCount > 0) {
      return false;
    } else {
      return true;
    }
  }
  async submit() {
    if (this.checkBeforeSubmit()) {
      this.addTeam = [];
      // this.team.code = Math.floor(1000 + Math.random() * 9000);
      this.team.code = this.tournament.code;
      let j = -1;
      for (j = 0; j < this.players.length; j++) {
        if (this.players[j].isMain === true) {
          break;
        }
      }
      let mainKey = "";
      if (j > -1 && j !== this.players.length) {
        mainKey = this.players[j].id;
      } else {
        mainKey = this.apiService.getKey(
          `tournament-fixtures/${this.tournamentId}/`
        );
      }
      if (this.tournament.proAm) {
        mainKey = this.players[0].id;
      }

      let updates = {};
      this.team.startHole = parseInt(this.team.startHole);
      this.apiService
        .set(`tournament-fixtures/${this.tournamentId}/${mainKey}`, this.team)
        .then((result) => {
          this.apiService.set(
            "tournaments/" + this.tournamentId + "/enteries/" + mainKey,
            true
          );

          this.manualPlayers.forEach((item, key) => {
            if (this.tournament.proAm) {
              item.isMain = false;
            }
            if (item.isMain) {
              updates[
                `tournament-fixtures/${this.tournamentId}/${mainKey}/manual_players/${mainKey}`
              ] = {
                name: item.name,
                handicap: parseFloat(item.handicap + ""),
                handicapOriginal: parseFloat(item.handicap + ""),
              };
              updates[
                `tournament-fixtures/${this.tournamentId}/${mainKey}/handicaps/${mainKey}`
              ] =
                Math.round(
                  (this.slop_rating / 113) * parseFloat(item.handicap + "")
                ) * parseFloat("" + this.tournament.handicap_percentage / 100);
              updates[
                `tournament-fixtures/${this.tournamentId}/${mainKey}/handicapsOriginal/${mainKey}`
              ] = parseFloat(item.handicap + "");
              updates[
                `tournament-fixtures/${this.tournamentId}/${mainKey}/tournamentHandicap/${mainKey}`
              ] = parseFloat(item.handicap + "");
            } else {
              const manualKey = this.apiService.getKey(
                `tournament-fixtures/${this.tournamentId}/${mainKey}/manual_players`
              );
              updates[
                `tournament-fixtures/${this.tournamentId}/${mainKey}/manual_players/${manualKey}`
              ] = {
                name: item.name,
                handicap: parseFloat(item.handicap + ""),
                handicapOriginal: parseFloat(item.handicap + ""),
              };
              updates[
                `tournament-fixtures/${this.tournamentId}/${mainKey}/handicaps/${manualKey}`
              ] =
                Math.round(
                  (this.slop_rating / 113) * parseFloat(item.handicap + "")
                ) * parseFloat("" + this.tournament.handicap_percentage / 100);
              updates[
                `tournament-fixtures/${this.tournamentId}/${mainKey}/handicapsOriginal/${manualKey}`
              ] = parseFloat(item.handicap + "");
              updates[
                `tournament-fixtures/${this.tournamentId}/${mainKey}/tournamentHandicap/${manualKey}`
              ] = parseFloat(item.handicap + "");
            }
          });
          updates[`user-tournaments/${mainKey}/${this.tournamentId}`] = 1;
          this.players.forEach((item, key) => {
            // updates[
            //   `tournament-fixtures/${this.tournamentId}/${mainKey}/handicaps/${item.id}`
            // ] = parseFloat(item.handicap + "");
            updates[
              `tournament-fixtures/${this.tournamentId}/${mainKey}/handicaps/${item.id}`
            ] =
                Math.round(
                  (this.slop_rating / 113) * parseFloat(item.handicap + "")
                ) * parseFloat("" + this.tournament.handicap_percentage / 100);
            updates[
              `tournament-fixtures/${this.tournamentId}/${mainKey}/players/${item.id}`
            ] = true;
            updates[
              `tournament-fixtures/${this.tournamentId}/${mainKey}/handicapsOriginal/${item.id}`
            ] = parseFloat(item.handicap + "");
            updates[
              `tournament-fixtures/${this.tournamentId}/${mainKey}/tournamentHandicap/${item.id}`
            ] = parseFloat(item.handicap + "");
            if (this.tournament.team > 0 && this.tournament.teamPlay > 0 && item.id != mainKey)
            {
              updates[`user-tournaments/${item.id}/${this.tournamentId}`] = 4;
            }
          });
          return this.apiService.bulkUpdate(updates);
        })
        .then(() => {
          // this.snackBar.open("Team is added", "OK!", {
          //   duration: 3000,
          // });
          alert("Team is added");
          this.players = [];
          this.manualPlayers = [];
          this.team = {
            name: "",
            startHole: 1,
          };
          this.counter = 0;
          // this.ngOnInit();
          //this.selectTab(0);
        });
    }
  }

  checkBeforeUpdate() {
    let teamCount = 0;
     if (this.teamData.name == ""|| this.teamData.name == "Team-") {
      alert("Please enter team name!!");
      return false;
     }
    
    let teamkey = this.teamData.$key
    let mainplayerExists = false;
    for (let player of this.uplayers) {
      console.log("player",player)
      if (player.id == teamkey)
      {
        mainplayerExists = true;
        }
      if (!player.name || player.name == "") {
        alert("Please enter player name!!");
        return false;
      }
      if ((player.thandicap == "" || player.thandicap == undefined || player.thandicap == null) && player.thandicap != 0) 
      {
        alert("Please enter player handicap!!");
        return false;
      }
    };

    if (!mainplayerExists)
    {
      alert("Please dont change team owner!!");
      return false;
    }
    
    for(let player of this.umanualPlayers){
      if (player.name == "") {
        alert("Please enter player name!!");
        return false;
      }
      if (player.handicap == "" && player.handicap!=0)
      {
        alert("Please enter player handicap!!");
        return false;
      }
    };
    
    
    
    if (this.tournament.team == 2) {
      let temp = true;
      for (let index = 0; index < this.uplayers.length; index++) {
        const element = this.uplayers[index];
        if (element.handicap == 0) {
          temp = false;
          break;
        }
      }

      if (temp) {
        alert("Atleast one Pro is required per team!");
        return false;
      }
    }

    if (this.tournament.proAm) {
      let proCount = 0;
      for (let index = 0; index < this.uplayers.length; index++) {
        const element = this.uplayers[index];
        if (element.handicap == 0) {
          ++proCount;
        }
      }

      if (proCount >= 2) {
        alert("Only one Pro is required per team!");
        return false;
      }
    }

    lodash.forEach(this.uplayers, (item, key) => {
      if (item.id == "" || item.id == null) {
        this.uplayers[key].isNameError = true;
      } else {
        ++teamCount;
        this.uplayers[key].isNameError = false;
      }
      if (item.handicap === "" || item.handicap === null) {
        this.uplayers[key].isHandicapError = true;
      } else {
        ++teamCount;
        this.uplayers[key].isHandicapError = false;
      }
    });
    lodash.forEach(this.umanualPlayers, (item, key) => {
      if (item.name == "" || item.name == null) {
        this.umanualPlayers[key].isNameError = true;
      } else {
        ++teamCount;
        this.umanualPlayers[key].isNameError = false;
      }
      if (item.handicap === "" || item.handicap === null) {
        this.umanualPlayers[key].isHandicapError = true;
      } else {
        ++teamCount;
        this.umanualPlayers[key].isHandicapError = false;
      }
    });
    if (teamCount > 0) {
      return true;
    } else {
      return false;
    }
  }
  async updateTeam() {
    if (this.checkBeforeUpdate()) {
      this.imageLoader = true;

      const uplayers = this.uplayers;
      const umanualPlayers = this.umanualPlayers;
      const teamKey = this.teamData.$key;

      $("#myModal23").modal("hide");

      const team = {
        name: this.teamData.name,
        startHole: parseInt(this.teamData.startHole),
        code: this.teamData.code,
      };


      let updates = {};

      updates[`tournament-fixtures/${this.tournamentId}/${teamKey}`] = null;
      updates[`tournament-players/${this.tournamentId}/${teamKey}`] = null;
      await this.apiService.bulkUpdate(updates);
      updates = {};
      updates[`tournament-fixtures/${this.tournamentId}/${teamKey}/name`] = team.name;
      updates[`tournament-fixtures/${this.tournamentId}/${teamKey}/startHole`] = team.startHole;
      updates[`tournament-fixtures/${this.tournamentId}/${teamKey}/code`] = team.code;

      updates[`tournament-players/${this.tournamentId}/${teamKey}/name`] = team.name;
      updates[`tournament-players/${this.tournamentId}/${teamKey}/startHole`] = team.startHole;
      updates[`tournament-players/${this.tournamentId}/${teamKey}/code`] = team.code;
       umanualPlayers.forEach((item, key) => {
            const manualKey = this.apiService.getKey(
              `tournament-fixtures/${this.tournamentId}/${teamKey}/manual_players`
            );

            updates[
              `tournament-fixtures/${this.tournamentId}/${teamKey}/manual_players/${manualKey}`
            ] = { name: item.name, handicap: parseFloat(item.thandicap + "") };
            updates[
              `tournament-fixtures/${this.tournamentId}/${teamKey}/handicaps/${manualKey}`
            ] =
              Math.round(
                (this.slop_rating / 113) * parseFloat(item.thandicap + "")
              ) * parseFloat("" + this.tournament.handicap_percentage / 100);
            updates[
              `tournament-fixtures/${this.tournamentId}/${teamKey}/handicapsOriginal/${manualKey}`
            ] = parseFloat(item.thandicap + "");
            updates[
              `tournament-fixtures/${this.tournamentId}/${teamKey}/tournamentHandicap/${manualKey}`
            ] = parseFloat(item.thandicap + "");
          });
          uplayers.forEach((item, key) => {
            if (item.id) {
            } else {
              item.id = item.$key;
            }

            updates[
              `tournament-fixtures/${this.tournamentId}/${teamKey}/handicaps/${item.id}`
            ] = Math.round(
                (this.slop_rating / 113) * parseFloat(item.thandicap + "")
              ) * parseFloat("" + this.tournament.handicap_percentage / 100);
            updates[
              `tournament-fixtures/${this.tournamentId}/${teamKey}/players/${item.id}`
            ] = true;

            updates[
              `tournament-fixtures/${this.tournamentId}/${teamKey}/handicapsOriginal/${item.id}`
            ] =
              parseFloat(item.thandicap + "");
            updates[
              `tournament-fixtures/${this.tournamentId}/${teamKey}/tournamentHandicap/${item.id}`
            ] =
              parseFloat(item.thandicap + "");
          });

      
      umanualPlayers.forEach((item, key) => {
            const manualKey = this.apiService.getKey(
              `tournament-players/${this.tournamentId}/${teamKey}/manual_players`
            );

            updates[
              `tournament-players/${this.tournamentId}/${teamKey}/manual_players/${manualKey}`
            ] = {
              name: item.name,
              handicap: parseFloat(item.thandicap + ""),
              handicapOriginal: parseFloat(item.thandicap + ""),
            };
            updates[
              `tournament-players/${this.tournamentId}/${teamKey}/handicaps/${manualKey}`
            ] =
              Math.round(
                (this.slop_rating / 113) * parseFloat(item.thandicap + "")
              ) * parseFloat("" + this.tournament.handicap_percentage / 100);
            updates[
              `tournament-players/${this.tournamentId}/${teamKey}/handicapsOriginal/${manualKey}`
            ] = parseFloat(item.thandicap + "");
            updates[
              `tournament-players/${this.tournamentId}/${teamKey}/tournamentHandicap/${manualKey}`
            ] = parseFloat(item.thandicap + "");
          });
          uplayers.forEach((item, key) => {
            if (item.id) {
            } else {
              item.id = item.$key;
            }

            updates[
              `tournament-players/${this.tournamentId}/${teamKey}/handicaps/${item.id}`
            ] = Math.round(
                (this.slop_rating / 113) * parseFloat(item.thandicap + "")
              ) * parseFloat("" + this.tournament.handicap_percentage / 100);
            updates[
              `tournament-players/${this.tournamentId}/${teamKey}/players/${item.id}`
            ] = true;

            updates[
              `tournament-players/${this.tournamentId}/${teamKey}/handicapsOriginal/${item.id}`
            ] = parseFloat(item.thandicap + "");
            updates[
              `tournament-players/${this.tournamentId}/${teamKey}/tournamentHandicap/${item.id}`
            ] = parseFloat(item.thandicap + "");
          });
          this.players = [];
          this.manualPlayers = [];
          this.team = {
            name: "",
            date: new Date(),
            startHole: 1,
          };
      
      
          // this.ngOnInit();
          this.apiService.bulkUpdate(updates);
          this.ucounter = 0;
          setTimeout(() => {
                // location.reload();
                // this.snackBar.open("Team is updated", "OK!", {
                //   duration: 3000,
                // });
                alert("Team is updated");
                this.players = [];
                this.manualPlayers = [];
                this.team = {
                  name: "",
                  date: new Date(),
                  startHole: 1,
                };
                this.counter = 0;
                // this.ngOnInit();
                //this.selectTab(0);
                this.imageLoader = false;
              }, 2000);
    }
  }

  checkboxChange1(checked: Boolean) {
    if (checked) {
      this.notificationList.map((list) => {
        list.isNotification = true;
      });
    } else {
      this.notificationList.map((list) => {
        list.isNotification = false;
      });
    }
  }

  checkboxChange2(checked: Boolean) {
    if (checked) {
      this.emailList.map((list) => {
        list.isEmail = true;
      });
    } else {
      this.emailList.map((list) => {
        list.isEmail = false;
      });
    }
  }

  deleteTeam() {
    if (confirm("Are you sure, you want to delete this team?")) {
      let update = {};
      update[
        `tournament-players/${this.tournamentId}/${this.teamData.$key}`
      ] = null;
      update[
        `tournament-fixtures/${this.tournamentId}/${this.teamData.$key}`
      ] = null;
      update[
        `tournaments/${this.tournamentId}/leaderboard/${this.teamData.$key}`
      ] = null;
      update[
        `tournaments-results/${this.tournamentId}/${this.teamData.$key}`
      ] = null;
      update[
        `/user-tournaments/${this.teamData.$key}/${this.tournamentId}`
      ] = 0;

      lodash.forEach(this.teamData.players, (value, key) => {
        update[
          `/user-tournaments/${key}/${this.tournamentId}`
        ] = 0;
      });

      update[
        `tournaments/${this.tournamentId}/enteries/${this.teamData.$key}`
      ] = null;

      this.apiService
        .bulkUpdate(update)
        .then(() => {
          // this.ngOnInit();
          location.reload();
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
  printToCart(printSectionId: string) {
    this.getTournamentTeams();
    let popupWinindow;
    const innerContents = document.getElementById(printSectionId).innerHTML;
    popupWinindow = window.open(
      "",
      "_blank",
      "width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no"
    );
    popupWinindow.document.open();
    popupWinindow.document.write(
      '<html><head></head><body onload="window.print()">' +
        innerContents +
        "</html>"
    );
    popupWinindow.document.close();
  }

  formatDate(date) {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    return day + " " + monthNames[monthIndex] + " " + year;
  }
  formatTime(timestamp) {
    const date = new Date(timestamp * 1000);

    // const time1 = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`

    return date.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: false,
    });
  }
  public onChange(event, type) {
    switch (type) {
      case 1:
        this.apiService.set(
          `/tournaments/${this.tournamentId}/isFixtureShow`,
          event.checked
        );

        break;

      case 2:
        this.apiService.set(
          `/tournaments/${this.tournamentId}/isLast3ScoreHide`,
          event.checked
        );

        break;
    }
  }

  public removeEnteries(user, i) {
    if (confirm("Are you sure, you want to delete this player?")) {
      var update = {};
      update[`/user-tournaments/${user.$key}/${this.tournamentId}`] = 0;
      update[
        `/tournament-followings/${this.tournamentId}/followings/${user.$key}`
      ] = null;
      update[`/tournaments/${this.tournamentId}/enteries/${user.$key}`] = null;
      update[
        `/user-tournament-scorecard-appversion/${user.$key}/${this.tournamentId}`
      ] = null;
      update[`tournament-fixtures/${this.tournamentId}/${user.$key}`] = null;
      update[`tournaments-results/${this.tournamentId}/${user.$key}`] = null;
      update[`tournament-players/${this.tournamentId}/${user.$key}`] = null;
      update[
        `tournaments/${this.tournamentId}/leaderboard/${user.$key}`
      ] = null;
      this.apiService.bulkUpdate(update);
      // this.enteries
    }
  }

  public toggleImage() {
    this.isShowImage = !this.isShowImage;
  }
  async isLiveChange(event) {
    try {
      let stroryId = this.apiService.getKey("server-process/user-story");

      let req: any = {
        storyProductId: this.tournamentId,
        authorId: this.tournament.cid,
        type: 1,
      };
      if (event) {
        this.tournament.storyProductId = stroryId;

        this.tournament.userStoryId = stroryId;
        let data = await this.apiService.set(
          `/server-process/user-story/${stroryId}`,
          req
        );
        await this.apiService.set(
          `/tournaments/${this.tournamentId}/userStoryId`,
          stroryId
        );
        await this.apiService.set(
          `/tournaments/${this.tournamentId}/goLive`,
          true
        );
      } else {
        req.isDeleted = true;
        // let data = await this.apiService.set(`/user-stories/${this.tournamentId}/`, null)
        let newdata = await this.apiService.set(
          `/server-process/user-story/${this.tournament.userStoryId}/`,
          req
        );
      }
    } catch (error) {}
  }

  async getScore() {
    let result: Array<any> = [];
    let data = await this.apiService.object(
      `/tournaments-results/${this.tournamentId}/`
    );

    let len = Object.keys(data).length
    if (typeof data.$value == "object" && data.$value == null)
    {
      return []
    }

    await this.getTournamentPlayer();
    await this.sortLeaderboard();
    let holes = [];
    if (this.tournament.holesPart == 0) {
      for (let i = 1; i <= 18; i++) {
        holes.push(i);
      }
    } else if (this.tournament.holesPart == 1) {
      for (let i = 1; i <= 9; i++) {
        holes.push(i);
      }
    } else {
      for (let i = 10; i <= 18; i++) {
        holes.push(i);
      }
    }

    let map: any = {};
    map.name = "";
    map.email = "";
    map.handicap = "";
    holes.map((hole) => {
      map["h-" + hole] = "";
    });
    map.total = "";
    result.push(map);

    if (data.$exists()) {
      let playerKeys = Object.keys(data);

      this.leaderboards.map((p, i) => {
        let m: any = {};
        m.name =
          p.player.fullName != undefined ? p.player.fullName : p.player.name;
        m.email = p.player.email;

        m.handicap = Math.floor(p.player.handicap);
        let total = 0;
        holes.map((hole, index) => {
          if (
            data[p.owner.$key] != undefined &&
            data[p.owner.$key][index] != undefined
          ) {
            let score = data[p.owner.$key][index].scores[p.playerKey];
            m["h-" + parseInt(hole)] = score;
            total = total + score;
          }
        });
        m.total = total;
        result.push(m);
      });

      // playerKeys.map((key) => {
      //   let map: any = {};
      //   let total = 0;
      //   this.leaderboards.map((p) => {

      //       map.name = p.player.fullName;
      //       map.email = p.player.email;
      //       map.handicap = p.player.handicap;

      //   });
      //   let playedHoles = Object.keys(data[key]);
      //   playedHoles.map((h) => {
      //     let score = data[key][h]["scores"][key];
      //     map["h-" + (parseInt(h) + 1)] = score;
      //     total = total + score;
      //   });
      //   map.total = total;
      //   result.push(map);
      // });
    }

    return result;
  }

  async getPlayer(uid) {
    let promise = new Promise((resolve, reject) => {
      if (typeof uid == "string") {
        this.apiService.object("users/" + uid).then((result) => {
          result.key = uid;
          resolve(result);
        });
      }
    });
    return promise;
  }

  async sortLeaderboard() {
    if (this.tournament && this.leaderboards) {
      for (const teamKey of Object.keys(this.tournament.leaderboard)) {
        var teamScore = this.tournament.leaderboard[teamKey];
        for (const playerKey of Object.keys(teamScore)) {
          for (var i = 0; i < this.leaderboards.length; i++) {
            var element = this.leaderboards[i];
            if (playerKey == element.playerKey) {
              this.leaderboards[i] = teamScore[playerKey];
              this.leaderboards[i].player = element.player;
              this.leaderboards[i].owner = element.owner;
              this.leaderboards[i].handicap = element.handicap;

              this.leaderboards[i].playerKey = playerKey;
              this.leaderboards[i].enterStats = element.enterStats;
            }
          }
        }
      }
      await this.leaderboards.sort(function ($0, $1) {
        return $1.holeNumber - $0.holeNumber;
      });

      var isStableford = this.isStableford;
      await this.leaderboards.sort(function ($0, $1) {
        let netto1 = $0.nettoSum;
        let netto2 = $1.nettoSum;
        if (netto1 == undefined) {
          return 1;
        }
        if (netto2 == undefined) {
          return -1;
        }
        if (netto1 != netto2) {
          return isStableford ? netto2 - netto1 : netto1 - netto2;
        }
        let netto3 = $0.nettoSum9;
        let netto4 = $1.nettoSum9;
        if (netto3 != netto4) {
          return isStableford ? netto4 - netto3 : netto3 - netto4;
        }
        let netto5 = $0.nettoSum6;
        let netto6 = $1.nettoSum6;
        if (netto3 != netto4) {
          return isStableford ? netto6 - netto5 : netto5 - netto6;
        }
        let netto7 = $0.nettoSum3;
        let netto8 = $1.nettoSum3;
        if (netto7 != netto8) {
          return isStableford ? netto8 - netto7 : netto7 - netto8;
        }
        let netto9 = $0.nettoSum1;
        let netto10 = $1.nettoSum1;
        if (netto9 != netto10) {
          return isStableford ? netto10 - netto9 : netto9 - netto10;
        }
        return 0;
      });

      var position = 1;
      var p = 1;
      var previousPosition;
      var previousPoints;
      var playType = this.tournament.teamPlay;
      this.leaderboardList = [];
      // We need to do this manually instead of map because we need access to next and previous item
      for (const result of this.leaderboards) {
        // if(result.finished== true){
        //   // alert('33')
        //   var isFinished = true;
        // }

        let positionItem: any;
        let nextPoints =
          p < this.leaderboards.length ? this.leaderboards[p].nettoSum : null;

        if (previousPoints != null && previousPoints == nextPoints) {
          positionItem = {
            position: position,
            result: result,
            type: playType,
            tiePosition: true,
          };
          previousPosition = position;
        } else if (
          previousPoints != null &&
          previousPoints == result.nettoSum
        ) {
          positionItem = {
            position: position,
            result: result,
            type: playType,
            tiePosition: true,
          };
          position = p + 1;
        } else if (nextPoints != null && nextPoints == result.nettoSum) {
          positionItem = {
            position: position,
            result: result,
            type: playType,
            tiePosition: true,
          };
          previousPosition = position;
        } else {
          positionItem = {
            position: p,
            result: result,
            type: playType,
            tiePosition: false,
          };
          previousPosition = position;
          position = p + 1;
        }

        p = p + 1;
        previousPoints = result.nettoSum;
        this.leaderboardList.push(positionItem);
      }
    }
  }

  async getTournamentPlayer() {
    var result = await this.getTeams().then(result);
    if (result) {
      this.leaderboards = [];
      for (const teamKey of Object.keys(result)) {
        const team = result[teamKey];

        var owner = await this.getPlayer(teamKey);

        if (team.players) {
          for (const playerKey of Object.keys(team.players)) {
            var obj = {
              player: {},
              playerKey: "",
              owner: {},
              handicap: {},
              enterStats: false,
            };
            obj.player = await this.getPlayer(playerKey).then(result);
            obj.handicap = team.handicaps[playerKey].toFixed(1);
            obj.playerKey = playerKey;
            obj.enterStats = team.enterStatus
              ? team.enterStatus
              : team.enterStats;
            obj.owner = owner;
            this.leaderboards.push(obj);
          }
        }

        if (team.manual_players) {
          for (const playerKey of Object.keys(team.manual_players)) {
            var obj = {
              player: {},
              playerKey: "",
              owner: {},
              handicap: {},
              enterStats: false,
            };
            obj.player = team.manual_players[playerKey];
            obj.enterStats = team.enterStatus
              ? team.enterStatus
              : team.enterStats;

            obj.handicap = team.handicaps[playerKey].toFixed(1);
            obj.owner = owner;
            obj.playerKey = playerKey;
            this.leaderboards.push(obj);
          }
        }
      }
    }
  }

  async getTeams() {
    return new Promise((resolve, reject) => {
      this.apiService
        .object("tournament-players/" + this.tournamentId)
        .then((result) => {
          resolve(result);
        });
    });
  }

  async downloadFile() {
    this.imageLoader = true;
    let data: Array<any> = await this.getScore();
    if (!data.length)
    {
      alert("No one played this tournament yet")
      this.imageLoader = false;
      return
    }
    const replacer = (key, value) => (value === null ? "" : value);
    const header = Object.keys(data[0]);
    let csv = data.map((row) =>
      header
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(",")
    );
    csv.unshift(header.join(","));
    let csvArray = csv.join("\r\n");

    var a = document.createElement("a");
    var blob = new Blob([csvArray], { type: "text/csv" }),
      url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = this.tournament.eventName + ".csv";
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
    this.imageLoader = false;
  }

  sendNotification() {
    let users = {};
    this.notificationList.map((notification) => {
      if (notification.isNotification) {
        users[notification.$key] = true;
      }
    });

    let body = {
      title:
        this.tournament.type == 2
          ? "Matchplay"
          : this.tournament.type == 1
          ? "Stableford"
          : this.tournament.type == 0
          ? "Strokeplay"
          : "",
      body: this.notificationMessage,
      type: 19,
      cid: this.tournament.cid,
      tournament: this.tournamentId,
    };

    let notifications = {};
    this.notificationList.map((notification) => {
      if(notification.isNotification)
      notifications[
        `server-process/admin-notification/${notification.$key}/${this.tournament.userId}`
      ] = body;
    });

    this.apiService
      .bulkUpdate(notifications)
      .then((data) => alert("Notification Sent"));
  }

  sendEmail() {
    let users = {};
    this.emailList.map((email) => {
      if (email.isEmail) {
        users[email.$key] = true;
      }
    });

    if (Object.keys(users).length !== 0) {
      let body = {
        subject:
          this.tournament.type == 2
            ? "Matchplay"
            : this.tournament.type == 1
            ? "Stableford"
            : this.tournament.type == 0
            ? "Strokeplay"
            : "",
        text: this.emailMessage,
        users: { ...users },
      };

      let notifications = {};
      this.notificationList.map((notification) => {
        if(notification.isEmail) 
        notifications[`server-process/admin-send-custom-email/`] = body;
      });

      this.apiService
        .bulkUpdate(notifications)
        .then((data) => alert("Email Sent"));
    } else {
      alert("No user selected!");
    }
  }

  getRoundUp(handicap) {
    return Math.round(handicap);
  }

  choosePlayer(event) {
    let item = event.player;
    item.user = event.player;
    if (this.addTeam.filter((player) => player.$key == item.$key).length > 0)
    {
      alert('This player is already added in Team');
      return;
    }
    else
    {
      this.addTeam.push(item);
      let temp = [];
      this.addTeam.forEach(player => {
        temp.push(player.$key);
      });
      this.syncLocalTeams.next({players: temp});
    }
    $("#invite-users-new").modal('hide');
  }

  removePlayerFromTeam(player, index) {
    this.addTeam.splice(index, 1);
  }

  async saveTeam()
  {
    this.addTeam[0].isMain = true;
    this.players = this.addTeam;
    await this.submit();
    
  }

  addIndividualEntry(event)
  {
    let item = event.player;
     if (!item) {
        alert('Please select one player')
        return
     }
    if (confirm('Are you sure, you want to add this player?')) {
      const element = item.$key;
      var update = {}
      var users = {}
      update[`/user-tournaments/${element}/${this.tournamentId}`] = 1
      update[`/tournament-followings/${this.tournamentId}/followings/${element}`] = null;
      update[`/tournaments/${this.tournamentId}/enteries/${element}`] = true
      update[`/user-tournament-scorecard-appversion/${element}/${this.tournamentId}`] = {
                    "userType": "2",
                    "appType": 1,
                    "versionName": environment.version + "",
                    "versionCode": environment.version + "",
                    "platformType": "3",
                    "osVersion": navigator.platform,
                    "brandName": navigator.vendor,
                    "modelName": navigator.userAgent,
                    "imei": "",
                    "createdAt": new Date().getTime() / 1000
                }
      users[element] = true
    }

    let notify = {
                body: "Golfhubber added you in a tournament",
                title: "Golfhubber",
                users: users,
                type: 19,
                cid: this.tournament.cid,
                tournament: this.tournamentId

    }
    
    update["server-process/admin-notification/" + new Date().getTime() + "/" + new Date().getTime()] = notify;
            console.log(update)
            this.apiService.bulkUpdate(update)
                .then(() => {
                    $('#invite-users-new').modal('hide');
                    // location.reload()
                   
                })
                .catch(error => {
                    console.error(error);
                });
  }

}
